import { render, staticRenderFns } from "./HdzsContent.vue?vue&type=template&id=44e36a5f&scoped=true&"
import script from "./HdzsContent.vue?vue&type=script&lang=js&"
export * from "./HdzsContent.vue?vue&type=script&lang=js&"
import style0 from "./HdzsContent.vue?vue&type=style&index=0&id=44e36a5f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e36a5f",
  null
  
)

export default component.exports